module.exports = __webpack_public_path__ + "img/honor.ad48b215.jpg";